module.exports = __webpack_public_path__ + "img/9788950950668.3b2ee519.jpg";